import { Fragment } from "react";

/**
 * TabularDigits — width-stable numerals for a font without `tnum` (FLAT-002).
 *
 * Anton carries no tabular-figures OpenType feature, so `font-variant-numeric:
 * tabular-nums` is inert wherever Anton renders a number (proven by probe:
 * plain/tnum/tnum+lnum all measure identically unequal). Until the MATCHDAY
 * §1.3 numeral-set decision lands, every scoreboard-class numeral that ticks
 * or aligns renders through this: each digit sits in a fixed 1ch cell (the
 * advance width of "0"), centred, so "1111" and "8888" occupy identical width
 * and ticking values never breathe. Non-digits (R , . : –) render inline as-is.
 */
export function TabularDigits({ value, className }: { value: string; className?: string }) {
  return (
    <span className={className} data-tabular-digits="">
      {[...value].map((ch, i) => (
        <Fragment key={i}>
          {/\d/.test(ch) ? <span className="mdui-digit-cell">{ch}</span> : ch}
        </Fragment>
      ))}
    </span>
  );
}
